import Link from 'next/link';
import { FC } from 'react';
import * as React from 'react';

const PostCard: FC<{
  post: any;
}> = ({ ...props }) => {
  const post = props.post;
  return (
    <Link key={post.id} href={`/blog/${post.id}/`} className='group'>
      <div
        {...props}
        className={`w-full cursor-pointer rounded-sm px-4 py-4
            transition-all
            sm:space-y-1
            sm:px-6
        `}
      >
        <img
          className='aspect-[9/5] w-full rounded object-cover'
          src={post.coverImage}
          alt={post.title}
        />
        <div className='block items-center space-y-2 sm:flex sm:flex-row sm:space-x-3 sm:space-y-0'>
          <h3 className='mt-4 group-hover:underline'>{post.title}</h3>
        </div>
        <div className='font-400 pt-2	text-[18px] text-slate-400'>
          {post.subtitle}
        </div>
        {post.date && (
          <div className='pt-2'>
            <div className='text-sm text-gray-500'>{post.date}</div>
          </div>
        )}
      </div>
    </Link>
  );
};

export default PostCard;
